// extracted by mini-css-extract-plugin
module.exports = {"categories":"index-module--categories--2Ytza","category":"index-module--category--3qOYI"};